export const possibilities = {
  text: [
    'TextGeneration',
    'Completion',
    'Translation',
    'Summarization',
    'QuestionsandAnswers',
    'Paraphrasing',
    'TextEditingAssistance',
    'CodingHelp',
    'Conversation',
    'ContentIdeas',
    'PoetryandCreativeWriting',
    'FactsandInformation',
    'Simulation',
    'DataInterpretation',
    'Conceptualization',
    'InternetResearch',
  ],
  img: [
    'CreateImagesBasedonPrompts',
    'RemoveScratches',
    'MakethePhotoColorful',
    'IncreasethePhotosResolution',
    'RestoreFaces',
  ],
};
